
import { styled, Box, Typography, LinearProgress, Chip } from "@mui/material";

export const ListContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  padding: theme.spacing(3),
  // marginTop: theme.spacing(2), // Removed as Divider handles separation
  // marginBottom: theme.spacing(2),
}));

export const WorkerCard = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  '&:last-child': {
    marginBottom: 0,
  },
}));

export const WorkerHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  marginBottom: theme.spacing(2),
}));

export const WorkerName = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1rem',
  color: theme.palette.text.primary,
}));

export const WorkerId = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: theme.palette.text.secondary,
  marginTop: '2px',
}));

export const StatusChip = styled(Chip)<{ status?: string }>(({ theme, status }) => ({
  backgroundColor: status === 'Late' || status === 'Facility Rejected' || status === 'Facility Reject' || status === 'Worker Cancelled' ? '#FFEBEE' : '#D1FAE5',
  color: status === 'Late' || status === 'Facility Rejected' || status === 'Facility Reject' || status === 'Worker Cancelled' ? '#D32F2F' : '#10B981',
  fontWeight: 600,
  borderRadius: '6px',
  height: '24px',
}));

export const DurationText = styled(Typography)(({ theme }) => ({
  textAlign: 'right',
  fontSize: '0.75rem',
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(0.5),
}));

export const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 6,
  borderRadius: 3,
  backgroundColor: '#F3F4F6',
  '& .MuiLinearProgress-bar': {
    backgroundColor: '#10B981', // Green for progress
    borderRadius: 3,
  },
}));

export const TimeContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: theme.spacing(1),
}));

export const TimeLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.75rem',
  color: theme.palette.text.secondary,
  fontWeight: 600,
}));

export const TimeValue = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: theme.palette.text.primary,
  fontWeight: 500,
}));

export const CountdownBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  backgroundColor: '#FEF3C7', // Light yellow for warning/notice
  padding: theme.spacing(1),
  borderRadius: '6px',
  marginBottom: theme.spacing(2),
}));

export const CountdownText = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: '#D97706', // Dark yellow/orange
  fontWeight: 500,
}));

export const EndShiftButton = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  width: '100%',
}));
